var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warn-pop"},[_c('div',{staticClass:"warn-icon"},[_c('icon',{attrs:{"iconType":"info_warning","size":32}})],1),_vm._v(" "),_c('div',{staticClass:"warn-msg"},[_vm._v("\n    "+_vm._s(_vm.value.msg)+"\n  ")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-901b01de","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pop/WarnPop.vue
// module id = null
// module chunks = 